import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

const formatXValue = (value) => {
  if (value?.includes('&')) {
    const fragments = value.split('&');
    return fragments[1] || value;
  }

  return value;
};

function capitalize(value) {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
  padding: ${theme.spaces.regular}px;
  border-radius: 8px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  background: ${theme.colors.white};
`;

const StyledCard = styled.div`
  .timestamp {
    margin-bottom: ${theme.spaces.smallX}px;
    font-family: 'Inter';
    font-size: ${theme.fontSizes.small}px;
    font-style: normal;
    font-weight: 400;
    color: ${theme.colors.gray.secondary};
  }
`;

const StyledCardContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: ${theme.spaces.smallX}px;

  .right-content {
    flex-grow: 1;

    .point {
      font-family: 'Inter';
      font-size: ${theme.fontSizes.regular}px;
      font-style: normal;
      font-weight: 400;
      color: ${theme.colors.gray.primary};

      .serie-id {
        font-weight: 600;
      }
    }
  }
`;

const StyledGroupColorBox = styled.div`
  height: 20px;
  width: 20px;

  ${({ color }) =>
    color &&
    css`
      background: ${color};
    `}
`;

const Tooltip = ({ points }) => {
  return (
    <StyledContainer>
      {points?.map(({ id, color, serieId, data = {} }, idx) => {
        const timestamp = formatXValue(data.xFormatted);

        return (
          <StyledCard key={id}>
            {!idx && <div className="timestamp">{timestamp}</div>}
            <StyledCardContent>
              <div className="left-content">
                <StyledGroupColorBox color={color} />
              </div>
              <div className="right-content">
                <div className="point">
                  <div className="serie-id">{capitalize(serieId)}</div>
                  <div className="value">{data.yFormatted}</div>
                </div>
              </div>
            </StyledCardContent>
          </StyledCard>
        );
      })}
    </StyledContainer>
  );
};

Tooltip.propTypes = {
  points: PropTypes.arrayOf(PropTypes.object),
};

export default Tooltip;
